// src/pages/expert/MissionsRedirect.jsx
// Les Missions vivent désormais DANS le shell expert (onglet interne du dashboard).
// On conserve l'URL historique /expert/missions (liens, reload, partage) en la
// redirigeant vers /expert/dashboard?tab=missions en préservant les query params
// (new, focus, mtype, mtitle, client, collection, origin, fp, draft…).
import React from "react";
import { Navigate, useLocation } from "react-router-dom";

export default function MissionsRedirect() {
  const loc = useLocation();
  const extra = loc.search ? `&${loc.search.replace(/^\?/, "")}` : "";
  return <Navigate to={`/expert/dashboard?tab=missions${extra}`} replace />;
}
